import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const titulaciones = [
  { id: 0, nombre: "DUE" },
  { id: 1, nombre: "GRADO" },
  { id: 2, nombre: "HOMOLOGACION DE TITULO" },
];

const SelectTitulacionPrincipal = ({
  name,
  label,
  value,
  onChange,
  error,
  helperText,
}) => {
  return (
    <FormControl fullWidth error={!!error}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        labelId={`${name}-label`}
        name={name}
        value={value !== undefined && value !== null ? value : ""}
        onChange={onChange}
        label={label}
      >
        <MenuItem value="">
          <em>Seleccione una opción</em>
        </MenuItem>
        {titulaciones.map((t) => (
          <MenuItem key={t.id} value={t.id}>
            {t.nombre}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <p style={{ color: "#d32f2f", fontSize: "0.75rem", margin: "3px 14px 0" }}>
          {helperText}
        </p>
      )}
    </FormControl>
  );
};

export default SelectTitulacionPrincipal;